// ═══════════════════════════════════════════════════════════
// Статус каналів звʼязку тенанта — один запит, спільний кеш.
//
// «Комунікація» і картка клієнта питають одне й те саме: чи є бот, як
// він зветься, чи налаштовано SMS та пошту. Картка відкривається десятки
// разів на день — без кешу це десятки однакових запитів (а раніше ще й
// getMe у Telegram на кожне відкриття).
//
// Кеш скидається на збереженні відповідних налаштувань, щоб «підключив
// Telegram → відкрив діалог» не показувало старий стан.
// ═══════════════════════════════════════════════════════════
import { apiFetch } from './api';

const TTL = 5 * 60 * 1000;
let cache = null;      // { data, ts }
let inflight = null;   // Promise — паралельні виклики чекають один запит

export function invalidateChannelsStatus() {
  cache = null;
  inflight = null;
}

/**
 * @returns {Promise<{telegram:{configured:boolean,username:string|null},
 *   sms:{configured:boolean,provider:string|null,sender:string|null},
 *   email:{configured:boolean,fromName:string|null,fromEmail:string|null},
 *   defaultPriority:{order:string[],enabled:Object}|null}>}
 */
export function getChannelsStatus({ force = false } = {}) {
  if (!force && cache && Date.now() - cache.ts < TTL) return Promise.resolve(cache.data);
  if (!inflight) {
    inflight = apiFetch('/api/channels-status')
      .then((data) => { cache = { data, ts: Date.now() }; inflight = null; return data; })
      .catch((err) => { inflight = null; throw err; });
  }
  return inflight;
}
